const FaqCta = () => {
  return (
    <div>
      <div className="text-center py-11">
        <h3 className="text-body-emphasis">Still can’t find your answer?</h3>
        <p className="text-body">Please, contact your system administrator</p>
      </div>
    </div>
  );
};

export default FaqCta;
